import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC } from "react";

interface ICompleteProductionOrderModal {
    open: boolean;
    onCompleteProductionOrder: (jobNumber: string) => void;
    onClose: () => void;
    user: string;
    jobNumber: string;
  }

  export const CompleteProductionOrderModal: FC<ICompleteProductionOrderModal> = ({
    open,
    onCompleteProductionOrder,
    onClose,
    user,
    jobNumber,
  }) => {
    const dialogHeader = "CSM Shopfloor";
  
    const buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
            onCompleteProductionOrder(jobNumber);
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
        },
        click: () => {
          onClose();
        },
      },
    ];
  
    const firstPosition = { X: 400, Y: 200 };
  
    return (
      <DialogComponent
        width="400px"
        close={onClose}
        header={dialogHeader}
        visible={open}
        showCloseIcon={true}
        buttons={buttons}
        position={firstPosition}
        isModal
      >
        {user}, are you sure that you want to complete production order {jobNumber}?
        This will send an email to Custom Solutions to build the job
      </DialogComponent>
    );
  };